import { DataRequestValueItemDto } from '../../../../../api-main';
import { SeriesGraphSettingsModel } from '../../models/SeriesGraphSettings.model';
import { UplotSeriesConfig } from '../../../../shared/components/graph-uplot/graph/models/UplotSeriesConfig.model';
import { getBaseUnitForScale } from '../../../../shared/components/graph-uplot/graph/utils/getBaseUnitForScale';

export function getSeriesForRequest(
  series: SeriesGraphSettingsModel[],
): DataRequestValueItemDto[] {
  return (series ?? [])
    .filter((o) => o.loggerId != null && o.valueId != null)
    .map((s) => ({
      logger_id: s.loggerId,
      value_id: s.valueId,
      consumption: s.consumption,
    }));
}

export function getSeriesConfig(
  series: SeriesGraphSettingsModel[],
  downloadedSeries: UplotSeriesConfig[],
): UplotSeriesConfig[] {
  return series
    .filter((s: SeriesGraphSettingsModel) => s.loggerId != null && s.valueId != null)
    .map((s: SeriesGraphSettingsModel, index: number) => ({
      ...s,
      label:
        s.label && s.label != ''
          ? s.label
          : s?.['name'] && s['name'] != ''
            ? s['name']
            : downloadedSeries[Number(index)]?.label,
      pathStyle: s.pathStyle ?? downloadedSeries[Number(index)]?.pathStyle,
      stroke: s.stroke ?? downloadedSeries[Number(index)]?.stroke,
      unit: s.unit && s.unit != '' ? s.unit : downloadedSeries[Number(index)]?.unit,
      scale: getBaseUnitForScale(s.unit) ?? null,
    }));
}
